export enum LovType {
  MARITAL_STATUS = 0,
  GENDER = 1,
  APPLICATION_MODULE = 2,
  ALERT_SEVERITY = 3,
  ALERT_STATUS = 4,
  ALERT_TYPE = 5,
  TITLE_TYPE = 10,
  TITLE_SUBTYPE = 11,
  PREMIUM_MODE = 12,
  //MANUAL_ACCOUNT_HOLDING_TYPE = 13,
  ADVISORY_FIRM_MGT_ROLE = 14,
  FIRM_TYPE = 15,
  PP_ACCOUNT_TYPES = 16,
  PP_ACCOUNT_REG = 17,
  PP_SECURITY_CLASS = 18,
  PP_ACCOUNT_STATUS = 19,
  PP_SECURITY_TYPE = 20,
  ACCOUNT_GROUP_TYPE = 21,
  ACCOUNT_CATEGORY = 22,
  COUNTRIES = 23,
  STATES = 24,
  CITIES = 25,
  TIME_H = 27,
  PROPOSAL_STATE = 28,
  POLICY_INSURANCE_TYPE = 29,
  POLICY_INSURANCE_SUBTYPE = 30,
  ANNUITY_TYPE = 31,
  ANNUITY_SUBTYPE = 32,
  ACCOUNT_TYPE = 33,
  OPERATIONAL_TYPE = 34,
  TAMP_TYPE = 35,
  PRODUCT_TYPE = 36,
  GENERAL_INVESTMENT_ACCOUNT_TYPES = 37,
  OTHER_INSURANCE_ACCOUNT_TYPES = 38,
  SECURITY_ASSET_CLASS = 40,
  DATA_SOURCE = 43,
  SUB_DATA_SOURCE = 44,
  ENTITY_TYPE = 45,
  TRUST_TYPE = 46,
  DOCUMENT_TYPE = 47,
  SF_TIME_ZONES = 48,
  SF_LANGUAGE = 49,
  SF_PROFILE = 50,
  SF_LOCALE = 51,
  SF_EMAIL_ENCODING = 52,
  REPORTING_PLATFORM = 53,
  ACCOUNT_STATUS = 54,
  SOURCE_OF_INITIAL_FUNDS = 55,
  SWEEP_STATUS = 56,
  EXTERNAL_SYSTEM_TYPE = 57,
  EXTERNAL_SYSTEM = 58,
  EMPLOYMENT_STATUS = 59,
  US_CITIZEN_STATUS = 60,
  BROKERAGE_TYPE = 61,
  PRICING_TYPE = 62,
  ACCOUNT_GROUP_VIEW = 63,
  CUST_MANNER_OF_GIFT = 64,
  RELATIONSHIP_TYPE = 65,
  BENEFICIARY_TYPE = 66,
  INDIVIDUAL_TYPE = 67,
  INVESTOR_LOGIN_OPTION_TYPE = 68,
  INVESTOR_LOGIN_LANDING_PAGE_TYPE = 69,
  FUNDING_SOURCE = 70,
  DOCUMENT_DELIVERY_METHOD = 71,
  ACCOUNT_PURPOSE = 72,
  TRUSTED_CONTACT_REL_TYPE = 73,

  ACC_ACTIVITY = 75,
  ACC_ACTIVITY_STATUS = 76,

  UPDATE_FREQUENCY = 80,

  BI_DICTIONARY = 90,
  COMPARISON_OPERATOR = 91,
  TASK_AUTOMATION = 92,
  WORKFLOW_STEP_PERMISSION = 93,

}

export enum InvestorLoginOption {
  SHOW_SLEEVES = 0,
  SHOW_POINT_TO_POINT_PERFORMANCE = 1,
  LANDING_PAGE = 2,
  SHOW_HISTORICAL_ASSET_ALLOC_CHARTS_GROUPLEVEL = 3,
  SHOW_HISTORICAL_ASSET_ALLOC_CHARTS_ACCTLEVEL = 4
}

export enum LandingPage {
  DASHBOARD = 0,
  HOUSEHOLD_DASHBOARD = 1
}

export enum ReportingPlatform {
  ADVISOROP = 0,
  LASERAPP = 1
}

export enum DataSource {
  PORTFOLIO_ACCOUNTING_SYSTEM = 1,
  MANUAL = 2
}

export enum TokenType {
  FORGET_PASSWORD = 0, //user forget password and ask to reset it 
  SETUP_ACCOUNT = 1 //first sign on
}

export enum RecordStatus {
  NEW = 0, //record is in the phase of creating

  ACTIVE = 5, //record is created and ready to use

  DELETED = 10 //record is deleted
}

export enum RepGroupFeeOptions {
  NO_FEES,
  WITH_FEES,
  BOTH
}

export enum AdvisoryRoles {
  ADVISORY = <any>'ADVISORY',
  ADVISORY_LEAD = <any>'ADVISORY_LEAD',
  ADVISORY_ADMIN = <any>'ADVISORY_ADMIN',
  SERVICER_ADMIN = <any>'SERVICER_ADMIN',
  SERVICER_TRADER = <any>'SERVICER_TRADER',
  SERVICER_HQ = <any>'SERVICER_HQ'
}

export enum TitleType {
  INDIVIDUAL = 0,
  INDIVIDUAL_TRANSFER_ON_DEATH,
  JOINT_TENANT = 2,
  JOINT_TRANSFER_ON_DEATH,
  CUSTODIAL = 4,
  TRUST = 5,
  SOLE_PROPRIETOR,
  CORPORATION = 7,
  LLC,
  INDIVIDUAL_SINGLE_MEMBER_LLC = 9,
  NON_PROFIT_ORGANIZATION,
  PARTNERSHIP = 11,
  ESTATE,
  _529_PLAN_ACCOUNT = 13,
  IRA,
  OTHER_RETIREMENT = 15,
  OTHER
}

export enum TitleSubtype {
  COMMUNITY_PROPERTY_WITH_RIGHTS_OF_SURVIVORSHIP = 0,
  TENANTS_IN_COMMON = 1,
  TENANTS_BY_ENTIRETY = 2,
  JOINT_TENANTS_WITH_RIGHTS_OF_SURVIVORSHIP = 3,
  USUFRUCT_LA_RESIDENTS_ONLY = 4,
  COMMUNITY_PROPERTY = 5,
  UGMA = 6,
  UTMA = 7,
  REVOCABLE = 8,
  IRREVOCABLE = 9,
  C_CORP = 10,
  S_CORP = 11,
  C_CORP_LLC = 12,
  S_CORP_LLC = 13,
  PARTNERSHIP = 14,
  DISREGARDED_ENTITY = 15,
  ADMINSTRATOR = 16,
  PERSONAL_REPRESENTATIVE = 17,
  EXECUTOR_EXECUTRIX = 18,
  INHERITED = 19,
  TRADITIONAL = 20,
  ROLLOVER = 21,
  ROTH = 22,
  SEP = 23,
  SIMPLE = 24,
  PROFIT_SHARING_PLAN = 25,
  MONEY_PURCHASE_PLAN = 26,
  I403_B = 27,
  I401_K = 28,
  INDIVIDUAL_K = 29,
  OTHER = 30,
  TESTAMENTARY = 31,
  FAMILY = 32,
  CHARITABLE = 33,
  LIVING = 34,

  UNDEFINED = 99
}

export enum InvestmentType {
  INDIVIDUAL_HOLDINGS = 1,
  MANAGED_MODELS,
  DIRECT_INVESTMENT,
  OUTSIDE_INVESTMENT,
  // Custodian accounts are not "investment" types but they are a special type of account that holds investments
  // And we need a type for these accounts so that we can classify and identify them.
  CUSTODIAN_ACCOUNT,
  SMA
}

export enum AccountCreationType {
  NEW_ACCOUNT = 1,
  ADD_TO_EXISTING_ACCOUNT,
  COPY_FROM_EXISTING_ACCOUNT
}

export enum AccountCreationShortcutType {
  CUSTODIAN = 1,
  DIRECT
}

export enum OperationalType {
  ADVISOR_AS_PORTFOLIO_MANAGER = 1,
  INDIVIDUAL_HOLDINGS
}

export enum TampType {
  INTERNAL_TAMP = 1,
  EXTERNAL_TAMP
}

export enum AccountCategory {
  INTERNAL = 1,

  EXTERNAL,

  ADVISOR_AS_PORTFOLIO_MANAGER,

  DIRECT_PRIVATE
}
export enum TitleInvestorRelationType {
  NONE = 0,

  MAJOR = 1,

  MINOR = 2
}
export enum AccountStatus {
  OPENING = 0,

  PROPOSED = 1,

  SETUP = 2,

  OPEN = 4,

  CANCELED = 10,

  CLOSED = 11
}
export enum AnnuityAccountStatus {
  OPEN = 4,
  CANCELED = 10,
  CLOSED = 11,
  SURRENDERED = 12,
  ANNUITIZED = 13,
  DEATH_CLAIM_PAID = 14,
  FULLY_PAID_OUT = 15,
  RETURNED = 16,
}
export interface IAnnuityAccountStatusName {
  value?: AnnuityAccountStatus;
  name: string;
}
export enum FirmType {
  REGISTERED_INVESTMENT_ADVISOR = 0,

  BROKER_DEALER = 1,

  MONEY_MANAGER = 2
}
export enum FeeType {
  CustodianFee = 0,

  PlatformFee = 10,

  AdvisorFee = 20
}
export enum ReportOutputFormat {
  PDF = 0,

  DOCX = 1,

  XPS = 2
}
export enum SystemLoginType {
  SERVICER = 0,

  ADVISOR = 1,

  INVESTOR = 2
}
export enum QuestionType {
  SELECT_ONE_OF_THE_LISTED = 0,

  ENTER_TEXT = 1,

  ENTER_DATE = 2
}
export enum QuestionnaireStatus {
  IN_PROGRESS = 0,

  FINSHED = 1
}
export enum RelationType {
  PRIMARY = 0,

  SECONDARY = 1
}
export enum Gender {
  MALE = 0,

  FEMALE = 1
}
export enum MaritalStatus {
  MARRIED = 1,

  SINGLE = 2,

  SEPARATED = 3,

  DIVORCED = 4,

  LIFE_PARTNER = 5,

  WIDOW = 6,

  UNKNOWN = 7
}

export enum MapType {
  PP = 0,

  REDTAIL = 1
}

export enum InvestorType {
  INDIVIDUAL = 0,

  COMPANY = 1
}
export enum RTQType {
  STANDARD = 0,

  EXPRESS = 1
}
export enum ReportTemplate {
  PROPOSAL = 0,

  PROPOSAL_SAMPLE,

  RTQ,

  SIA,

  PERSHINGOPENINGFORM = 4
}
export enum ProposalState {
  PREPARING = 0,

  ACTIVE = 1,

  SIGNED = 5,

  CANCELED = 10
}
export enum MarketValueBy {
  ADVISOR,

  INVESTOR,

  HOUSEHOLD,

  ADVISORY_FIRM
}
export enum ApplicationModules {
  ProposalTool = 5,

  RiskMonitor = 10,

  AccountMappingSystem = 15,

  UserTaskEntry = 20
}
export enum AlertSeverity {
  Informational = 0,

  FollowUpNeeded = 5,

  Warning = 10,

  Severe = 15,

  Critical = 20
}
export enum AlertStatus {
  ACTIVE = 1,

  COMPLETED = 5,

  ARCHIVED = 10,

  DELETED = 15
}
export enum AlertType {
  MESSAGE = 0,

  TASK = 5
}
export enum AlertSubType {
  Na = 0,
  RTGOutOfCompliance = 10,
  AccountOpening = 20,
  AccountActivated = 22,
  AccountCanceled = 25,
  AccountClosed = 27,
  ProposalNeedsToBeSigned = 30,
  ProposalDocumentationNeedsToBeUploaded = 35
}
export enum Currency {
  USD = 840,

  EUR = 970
}
export enum AdvisoryFirmMgtRole {
  MANAGED = 0,
  UNMANAGED
}
//export enum ManualAccountHoldingType {
//    INSURANCE = 0,

//    INVESTMENT = 1,

//    OTHER = 2,

//    ANNUITY = 3
//}



export enum PremiumMode {
  ANUAL = 0,

  QUARTERLY = 1,

  MONTHLY = 2
}
export enum AccountGroupType {
  RTG = 1,

  ADVISOR_DEFINED = 2,

  HOUSEHOLD = 3
}
export enum NotesType {
  INVESTOR = 0,

  HOUSEHOLD = 1,

  ACCOUNT = 2,

  ACCOUNT_GROUP = 3,

  MEETING = 4
}

export enum PolicyInsuranceType {
  PERMANENT_CASH_VALUE_LIFE_INSURANCE = 0,
  TERM_LIFE_INSURANCE = 1,
  OTHER = 2,

}

export enum ProductType {
  GENERAL_INVESTMENT = 1,
  P_529,
  REIT,
  ANNUITY,
  LIFE_INSURANCE,
  INVESTMENT_MODEL,
  RETIREMENT_PRODUCT,
  OTHER, /* SAVINGS_ACCOUNTS ????*/
  OTHER_INSURANCE,
  PRIVATE_PLACEMENT,
  HEDGE_FUND,
  MUTUAL_FUND
}

export enum AnnuityType {
  ANNUITIES_DEFERRED = 3,
  ANNUITIES_IMMEDIATE = 4
}

export enum AnnuitySubtype {
  //Annuities-Deferred
  VARIABLE_ANNUITY_BD_PRODUCT = 23,
  INDEXED_ANNUITY = 24,
  FIXED_ANNUITY_DEFERRED = 25,
  GUARANTEED_FIXED_ANNUITY = 26,
  INDEXED_LTC = 32,
  FIXED_INDEXED = 33,
  //Annuities-Immediate
  VARIABLE_ANNUITY_W_O_GMIB = 27,
  VARIABLE_ANNUITY_W_GMIB = 28,
  INDEXED_ANNUITY_W_O_GMIB = 29,
  INDEXED_ANNUITY_W_GMIB = 30,
  FIXED_ANNUITY_IMMEDIATE = 31
}

export enum PolicyInsuranceSubtype {
  WHOLE_LIFE_PARTICIPATING = 5,
  WHOLE_LIFE_NON_PARTICIPATING = 6,
  VARIABLE_WHOLE_LIFE_BD_PRODUCT = 7,
  UNIVERSAL_LIFE = 8,
  VARIABLE_UNIVERSAL_LIFE__BD_PRODUCT = 9,
  INDEXED_UNIVERSAL_LIFE = 10,
  GUARANTEED_UNIVERSAL_LIFE = 11,
  LONG_TERM_CARE__LIFE_INSURANCE_ASSET_BASED = 12,
  //term life insurance
  ANNUAL_RENEWABLE_TERM = 13,
  YEAR_5 = 14,
  YEAR_10 = 15,
  YEAR_20 = 16,
}

export enum PolicyOtherInsuranceType {
  DISABILITY_INCOME,
  DISABILITY_OVERHEAD,
  DISABILITY_BUYOUT,
  ACCIDENTAL_DEATH_AND_DISMEMBERMENT,
  SPECIALTY_COVERAGE,
  LONG_TERM_CARE_INDEMNITY_BASED
}

export enum GeneralInvestmentAccountType {
  SAVINGS_ACCOUNT = 0,
  CERTIFICATE_OF_DEPOSIT,
  MONEY_MARKET_ACCOUNT,
  INVESTMENT_ACCOUNT,
  OTHER
}

export enum AllocationPlanType {
  BO_SYSTEM_ALLOCATION_PLAN = 0,
  CUSTOM_ALLOCATION_PLAN = 1
}

export enum Status {
  INACTIVE = 0,
  ACTIVE = 1,
}

export enum StateFormat {
  TWO_DIGIT_CODE = 0,
  RAW_TEXT = 1
}

export enum ProductCatalogTabs {
  Managers = 1,
  Product_Types,
  Products
}

export enum EntityType {
  TRUST = 5,
  SOLE_PROPRIETOR = 6,
  CORPORATION = 7,
  LLC = 8,
  INDIVIDUAL_SINGLE_MEMBER_LLC = 9,
  NON_PROFIT_ORGANIZATION = 10,
  PARTNERSHIP = 11,
  ESTATE = 12
}

export enum TrustType {
  REVOCABLE = 1,
  IRREVOCABLE
}

export enum ProductAccess {
  DIRECT_ACCESS = 1,
  TAMP_ACCESS = 2
}

export enum CompensationType {
  COMMISSION_BASED = 1,
  FEE_BASED
}

export enum RiskBases {
  STYLE_BASED = 1,
  HOLDINGS_BASED
}

export enum ExternalSetup {
  USER_CREATED = 1,
  CLIENT_CREATED
}

//export enum ExternalSystems {
//  SALES_FORCE = 1,
//  REDTAIL = 2,
//  LASER_APP = 3,
//  PERSHING = 4,
//  PORTFOLIO_PATHWAY = 5,
//  DOCUSIGN = 6,
//  PORTFOLIO_PATHWAY_API = 7,
//  BOX = 8,
//  ADOBESIGN = 9
//}

export enum AlertsGetRule {
  SHOW_USER_ENTRY_TASKS = 1,
  SHOW_TASK_WORKFLOW,
  SHOW_ALL,
  SHOW_TASKS_RISK_MONITOR
}

export enum SyncDataType {
  ADVISOR_CREATE = 1,
  ADVISOR_UPDATE,
  ADVISOR_DELETE,
  EXTERNAL_CREATE,
  EXTERNAL_UPDATE,
  EXTERNAL_DELETE,
}

export enum ConfigurationType {
  ALL = -1,
  ADVISOR = 0,
  ADVISORY_FIRM,
  COMPANY_GROUP,
  INVESTOR
}

export enum SalesForceWizardStep {
  GLOBAL_AF_API = 1,
  GLOBAL_AF_CLASS_MAPP,
  GLOBAL_AF_TEST
}

export enum SalesForceClassMapStep {
  INVESTOR = 1,
  HOUSEHOLD
}

export enum SalesforceObject {
  user,
  account,
  contact,
  profile,
  costum = 9999
}

export enum AdvisorObject {
  investor,
  household
}

export enum ConfigurationLevel {
  NEW,
  EXISTING
}

export enum SweepStatus {
  NO_SWEEP = 0,
  ACTIVE = 1,
  CLOSED = 2,
  INACTIVE = 3
}

export enum SourceOfInitialFunds {
  ALIMONY = 0,
  ACCOUNTS_RECEIVABLE = 1,
  ACCUMULATED_SAVINGS = 2,
  INCOME_FROM_EARNINGS = 3,
  LOTTERY_GAMBLING_PROCEEDS = 4,
  GIFT = 5,
  INHERITANCE = 6,
  INVESTMENT_PROCEEDS = 7,
  INSURANCE_PROCEEDS = 8,
  LEGAL_SETTLEMENT = 9,
  OTHER = 10,
  RENTAL_INCOME = 11,
  SPOUSE_PARENT = 12,
  ROLLOVER = 13,
  PENSION_IRA_RETIREMENT_SAVINGS = 14,
  SALE_OF_BUSINESS = 15,
  SALE_OF_REAL_ESTATE = 16,
  UNKNOWN = 17,
}

export enum ExternalSystem {
  SALESFORCE = 1,
  REDTAIL,
  LASERAPP,
  PERSHING,
  PORTFOLIO_PATHWAY,
  DOCUSIGN,
  PORTFOLIO_PATHWAY_API,
  BOX,
  ADOBESIGN,
}

export enum ExternalSystemType {
  CRM,
  BACK_OFFICE,
  DOCUMENT_GENERATION,
  ESIGNATURE,
  CUSTODIAN,
  DMS
}

export enum DocumentType {

  INVESTMENT_PROPOSAL = 0,
  SUBSCRIPTION_AGREEMENT = 1,
  CUSTODIAN_ACCOUNT_OPENING_DOCUMENT = 2,
  DRIVERS_LICENSE = 3,
  PASSPORT = 4,
  ID_CARD = 5,
  BIRTH_CERTIFICATE = 6,
  MARRIAGE_CERTIFICATE = 7,
  CERTIFICATE_OF_NATURALIZATION = 8,
  CERTIFICATE_OF_CITIZENSHIP = 9,
  MILITARY_ID = 10,
  ENTITY_DOCUMENTATION = 11,
  RISK_TOLERANCE_QUESTIONNAIRE = 12,
  FINANCIAL_PLAN = 13,

  CLIENT_PROFILE = 14,
  CLIENT_PLANNING_INVOICE = 16,
  CLIENT_AGREEMENT = 17,
  SIGNED_CLIENT_AGREEMENT = 18,

  SIGNED_INVESTMENT_PROPOSAL = 100,
  SIGNED_SUBSCRIPTION_AGREEMENT = 101,
  SIGNED_CUSTODIAN_ACCOUNT_OPENING_DOCUMENT = 200,

  ACCOUNT_OPENING = 230,
  CUSTODIAL_ADOPTION = 231,
  BENEFICIARY_DESIGNATION = 232,
  TRUSTEE_CERTIFICATION = 233,
  IRA_ADOPTION = 234,
  ENTITY_CERTIFICATION = 235,
  PRIVATE_INVESTMENT = 236,
  ASSET_TRANSFER = 237,
  SIGNED_CUSTODIAL_ADOPTION = 238,
  SIGNED_BENEFICIARY_DESIGNATION = 239,
  SIGNED_TRUSTEE_CERTIFICATION = 240,
  SIGNED_IRA_ADOPTION = 241,
  SIGNED_ENTITY_CERTIFICATION = 242,
  SIGNED_PRIVATE_INVESTMENT = 243,
  SIGNED_ASSET_TRANSFER = 244,
  CASH_MANAGEMENT = 245,
  SIGNED_CASH_MANAGEMENT = 246,
  IRA_DISTRIBUTION = 247,
  SIGNED_IRA_DISTRIBUTION = 248,

  CHECK_INSTRUCTIONS = 270,
  ACH_FORM = 272,
  WIRE_INSTRUCTIONS = 274,

}

export enum EmploymentStatus {
  EMPLOYED = 0,
  SELF_EMPLOYED = 1,
  RETIRED = 2,
  UNEMPLOYED = 3,
  HOMEMAKER = 4,
  STUDENT = 5,
  UNKNOWN = 6
}

export enum USCitizenStatus {
  US_CITIZEN = 0,
  US_RESIDENT_ALIEN = 1,
  NONRESIDENT_ALIEN = 2,
  OTHER = 3
}

export enum PricingType {
  TRANSACTION_BASED = 0,
  ASSET_BASED = 1
}

export enum BrokerageType {
  CASH = 0,
  MARGIN = 1
}

export enum AccountGroupView {
  RTG = 1,
  ADG = 2,
  ALL = 3
}

export enum BeneficiaryType {
  PRIMARY,
  CONTINGENT
}

export enum RelationshipType {
  B,
  CC,
  CS,
  D,
  DP,
  E,
  F,
  FL,
  GF,
  GM,
  GD,
  GS,
  M,
  ML,
  NE,
  NI,
  O,
  OE,
  OI,
  SI,
  SO,
  SP,
  T
}

export enum IndividualType {
  INDIVIDUAL = 0,
  ENTITY = 1
}

export enum ExternalMappingType {
  ACCOUNTGROUPID_TO_HOUSEHOLDID = 0,
  CUSTODIANID_TO_CUSTODIANID = 1,
  MANAGERID_TO_CUSTODIANID = 2,
  ADVISORYFIRMID_TO_FIRMID = 3
}

export enum DashboardType {
  HOUSEHOLD = 0,
  ACCOUNTGROUP = 1,
}

export enum UserHierarchyRelation {
  ADVISORY_ADVISORY = 0,
  SERVICER_SERVICER = 1
}

export enum DocumentOrganization {
  ADVISOROP = 1,
  CUSTODIAN = 2,
  NONCUSTODIAN_SUBSCRIPTION = 3,
  INSURANCE = 4,
  ANNUITY = 5,
  OTHER = 100
}

export enum FundingSource {
  CHECK = 1,
  ACH,
  WIRE,
  TOA_FULL,
  TOA_PARTIAL,
  TBD = 100
}

export enum DocumentDeliveryMethod {
  EMAIL = 1,
  ELECTRONIC_SIGNATURE,
  IN_PERSON,
  MAIL
}

export enum DocumentRelation {
  INVESTOR = 1,
  ACCOUNT = 2
}

export enum UpdateFrequency {
  UNDEFINED = 0,
  DAILY = 1,
  BI_MONTHLY = 2,
  MONTHLY = 4,
  QUARTERLY = 8,
  BI_ANNUALLY = 16,
  ANNUALLY = 32
}

export enum BoSearchResultType {
  Manager = 0,
  Product = 1,
  Security = 2
}

export enum HistChartDateType {
  LAST_SIX_MONTHS = 1,
  LAST_FOUR_QUARTERS = 2,
  LAST_ONE_WEEK = 3
}

export enum AuthenticationCodeMethod {
  PHONE = 1,
  EMAIL = 2
}

export enum PositivityIndicator {
  POSITIVE = 1,
  NEGATIVE = 2,
  NEUTRAL = 3
}

export enum WorkflowShapes {
  TERMINATOR = 1,
  AOPROCESS = 2,
  AODECISION = 3
}

export enum WorkflowStepStatus {
  ACTIVE = 1, // Means that the step is the next active step, but is not yet completed.
  CLAIMED,
  COMPLETED,
  INACTIVE
}

export enum WorkflowPathTakenStatus {
  PATH_TAKEN = 1,
  PATH_REVERSED
}

export enum MeetingType {
  PHONE = 0,
  VIDEO = 1,
  IN_PERSON = 2
}

export enum MeetingStatus {
  RESERVED = 0,
  SCHEDULELATER = 1,
  SCHEDULED = 2,
}

export enum CalendarType {
  MEETING_HUB = 0,
  MS_GRAPH = 1
}

export enum MeetingHubControllers {
  UNKNOWN = 0,
  CALENDAR = 1 << 0,
  MEETING_CREATOR = 1 << 1,
  MEETING_AVAILABILITY_CREATOR = 1 << 2,
  MEETING_LIST = 1 << 3,
  MEETING_SELECTOR = 1 << 4
}

export enum DaysOfWeek {
  SUNDAY = 0,
  MONDAY,
  TUESDAY,
  WEDNESDAY,
  THURSDAY,
  FRIDAY,
  SATURDAY
}
export enum AssetClass {
  EQUITIES = 1,
  FIXED_INCOME = 2,
  ALTERNATIVE_ASSETS = 3,
  CASH = 4,
  NO_ALLOCATION = 5,
}
export enum BIDictionary {
  ACCOUNT_CASH_BALANCE_DECREASE = 1,
  ACCOUNT_CASH_BALANCE_INCREASE,
  ACCOUNT_CASH_PERCENTAGE,
  HOUSEHOLD_VALUE_DECREASE,
  HOUSEHOLD_VALUE_INCREASE,
  HOUSEHOLD_PERCENTAGE_DECREASE,
  HOUSEHOLD_PERCENTAGE_INCREASE,
  ACCOUNT_CASH_BALANCE,
  HOUSEHOLD_VALUE,
}
export enum ComparisonOperator {
  GREATER_THAN = 1,
  GREATER_THAN_OR_EQUAL_TO,
  LESS_THAN,
  LESS_THAN_OR_EQUAL_TO,
  EQUAL_TO,
  NOT_EQUAL_TO,
}
export enum AOAutomatedTask {
  ISSUE_RAISE_CASH_INSTRUCTION = 1,
  ISSUE_CASH_SEND_INSTRUCTION,
  SEND_DOCUEMENTATION_FOR_SIGNATURE,
  REQUEST_CLIENT_MEETING,
}
export enum WorkflowStepPermission {
  SERVICER = 1,
  TRADER,
  ADVISOR,
}
